import QRCode from 'react-qr-code'

export const WalletAddressQRCode = ({
  address,
  size = 200,
}: {
  address: string
  size: number
}) => {
  if (!address) return null

  return <QRCode value={address} size={size} level="H" />
}
